import { colors } from '../../colors';
var book = {
  fieldBorderColor: colors.darkNight,
  errorColor: colors.warningRed
};
export default book;